function storageAvailable(type) {
  try {
    var storage = global[type];
    var x = '__storage_test__';
    storage.setItem(x, x);
    storage.removeItem(x);
    return storage;
  } catch (e) {
    return false;
  }
}

export default class WebStorage {
  constructor() {
    this._data = new Map();
  }
  setItem(id, val) {
    return this._data.set(id, String(val));
  }
  getItem(id) {
    return this._data.has(id) ? this._data.get(id) : undefined;
  }
  removeItem(id) {
    return this._data.delete(id);
  }
  clear() {
    return this._data.clear();
  }
}

export { storageAvailable };

export const localStorage =
  storageAvailable('localStorage') || new WebStorage();
export const sessionStorage =
  storageAvailable('sessionStorage') || new WebStorage();
